import { initialState as filtersInitialState } from 'shared/legacy/contexts/SearchContext/FiltersContext/FilterContext';
import { create } from 'zustand';
import { CampaignFiltersState, CampaignFiltersStore } from './campaign-filters.store.types';

const initialState: CampaignFiltersState = {
  locations: filtersInitialState.filters.locations,
};

export const useCampaignFiltersStore = create<CampaignFiltersStore>()((set, get) => ({
  ...initialState,
  setFilter: (filterKey, callbackOrValue) => {
    const value = typeof callbackOrValue === 'function' ? callbackOrValue(get()[filterKey]) : callbackOrValue;

    set(() => ({ [filterKey]: value }));
  },
}));
